<mat-card appearance="outlined"
          class="p-0">

  <mat-card-title *ngIf="cardTitle">
    <div class="card-title-text">
      {{ cardTitle }}
      <ng-content class="card-title-actions" select="[card-title-actions]"></ng-content>
    </div>
    <mat-divider *ngIf="!hideDivider"></mat-divider>
  </mat-card-title>

  <mat-card-content class="{{contentClass}}">
    <ng-content></ng-content>
  </mat-card-content>

</mat-card>
